import React, {useState} from 'react';
import { Form, Button } from 'react-bootstrap';
import CustomButton from './CustomButton';
import emailjs from 'emailjs-com';

function ContactForm() {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [title, setTitle] = useState('WHATS YOUR PROJECT');
    const [submitted, setSubmitted] = useState(false);

    const getParams = () => {
        
    }

    const logFun = () => {
        console.log("LOG")
    };

    function sendEmail (e) {
        e.preventDefault();

        emailjs.sendForm('service_m80w69f', 'template_nydvfdo', e.target, 'user_BALw9N2Nttm4wbyF8QUUn',
        {
            name: {name},
            description: {message},
            email: {email}
        })
        .then(function(response) {
           
            if(response.status == 200){
                setSubmitted(true);
                setTitle('THANKS FOR SUBMITTING, WE WILL BE IN CONTACT.')
                console.log('SUCCESS!' + {submitted});
            }
         }, function(error) {
            alert("Reservation failed");
            console.log('FAILED...', error);
         });

        e.target.reset();
    }



    
    return (

        <div className="chat-content">
            <h1>{title}</h1>
            <div className="contact-form">
                {
                    submitted ?
                    <div></div>
                    :
                    <Form onSubmit={sendEmail}>
                        <p>Name</p>
                        <Form.Control className="contact-input" style={{borderRadius:'0px', border:'1px solid #00000050'}} required placeholder="Name" onChange={e=>setName(e.target.value)} name="name"/>
                        <p>Email</p>
                        <Form.Control className="contact-input" style={{borderRadius:'0px', border:'1px solid #00000050'}} required type="email" placeholder="Enter email"  onChange={e=>setEmail(e.target.value)} name="email"/>
                        <p>Project Description</p>
                        <Form.Control className="contact-input" as="textarea" rows={5} style={{borderRadius:'0px', border:'1px solid #00000050'}}  required placeholder="Enter Description"  onChange={e=>setMessage(e.target.value)} name="description"/>
                        {/* <Button variant="danger" type="submit">Danger</Button> */}
                        <Button type="submit" style={{backgroundColor:"rgb(0,0,0, 0.0)", border:"unset"}}>
                            <CustomButton text="LETS GET STARTED"  style={{backgroundColor:'#E92323'}}  type="submit"/>
                        </Button>
                    </Form>

                }
                
            </div>
        </div>
    )
}

export default ContactForm;
